/**
 * Construye el objeto `user` (mismo localStorage/authStore que usa el resto
 * de la app) para la identidad suplantada. El endpoint POST /api/impersonations
 * solo devuelve el JWT + claims de impersonación, no un perfil completo como
 * el login normal — se reconstruye a partir del Employee ya cargado en el
 * selector y de los `roles` decodificados del nuevo JWT (fuente real de
 * autorización). `permissions` se deja vacío a propósito: se rellena solo al
 * recargar la página, vía `authStore.refreshPermissions()` con el nuevo token.
 * canCreateTimeEntry/accessTrackerNetReports/accessInternalTickets/
 * accessVehicleModule siguen el mismo criterio: en el login normal los
 * calcula el backend a partir de EmployeePermission (no son columnas de
 * Employee), así que aquí no hay de dónde leerlos hasta ese mismo refresco —
 * se dejan en `false` en vez de fingir un valor con datos que ya no existen.
 */
export const buildImpersonatedUser = (employee, roles) => ({
  id: employee.id,
  name: employee.name,
  lastName: employee.lastName,
  email: employee.email,
  jobName: employee.job?.name ?? null,
  department: employee.job?.department ?? null,
  roles: roles ?? [],
  permissions: [],
  canCreateTimeEntry: false,
  accessTrackerNetReports: false,
  accessInternalTickets: false,
  accessVehicleModule: false,
  photo: employee.photo ?? "",
});
